export enum AIModalState {
  IDLE = "idle",
  UPLOADING = "uploading",
  UPLOADED = "uploaded",
  EXTRACTING = "extracting",
  ANALYZING = "analyzing",
  POLLING = "polling",
  SUCCESS = "success",
  ERROR = "error",
}

export enum AIFeatureType {
  PDF_EXTRACTION = "pdf_extraction",
  SINGLE_LINKAGE = "single_linkage",
  BATCH_LINKAGE = "batch_linkage",
  VOTING_ALIGNMENT = "voting_alignment",
  ENGAGEMENT_RATING = "engagement_rating",
}

export enum AIExtractionStatus {
  SUCCESS = "success",
  PARTIAL = "partial",
  FAILED = "failed",
}

export enum AILinkageType {
  THEMATIC_ALIGNMENT = "THEMATIC_ALIGNMENT",
  COMPLEMENTARY_ACTION = "COMPLEMENTARY_ACTION",
  ESCALATION_PATH = "ESCALATION_PATH",
  ISOLATED_ACTIVITY = "ISOLATED_ACTIVITY",
}

export enum AISequenceFlow {
  ENGAGEMENT_PRECEDES_VOTE = "ENGAGEMENT_PRECEDES_VOTE",
  VOTE_PRECEDES_ENGAGEMENT = "VOTE_PRECEDES_ENGAGEMENT",
  BIDIRECTIONAL = "BIDIRECTIONAL",
}

export enum AIInteractionClass {
  CONSISTENT_REINFORCEMENT = "CONSISTENT_REINFORCEMENT",
  INTERNAL_INCONSISTENCY = "INTERNAL_INCONSISTENCY",
  SYNERGISTIC_ALIGNMENT = "SYNERGISTIC_ALIGNMENT",
  ACTIVE_UNDERMINING = "ACTIVE_UNDERMINING",
}
